import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const sections = [
  {
    title: '1. 取得する個人情報',
    content: '当社は、お客様からのお問い合わせ・ご依頼の際に、以下の個人情報を取得する場合があります。お名前、会社名、メールアドレス、電話番号、お問い合わせ内容。',
  },
  {
    title: '2. 利用目的',
    content: '取得した個人情報は、お問い合わせへの回答、およびサービス提供のための連絡にのみ利用いたします。それ以外の目的で利用することはありません。',
  },
  {
    title: '3. 第三者提供',
    content: '取得した個人情報は、法令に基づく場合を除き、お客様の同意なく第三者に提供することはありません。',
  },
  {
    title: '4. 保管期間',
    content: '取得した個人情報は、お問い合わせ対応完了後、合理的な期間をもって適切に廃棄または削除いたします。',
  },
  {
    title: '5. 開示・訂正・削除の請求',
    content: 'ご自身の個人情報について、開示・訂正・削除をご希望の場合は、以下の窓口までご連絡ください。速やかに対応いたします。',
  },
  {
    title: '6. お問い合わせ窓口',
    content: '',
  },
  {
    title: '7. お問い合わせフォーム送信時の同意',
    content: 'お問い合わせフォームから送信いただいた時点で、本プライバシーポリシーに同意したものとみなします。',
  },
];

export default function Privacy() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />

      <section className="pt-24 md:pt-32 pb-16 md:pb-20">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-6">
                プライバシーポリシー
              </h1>
              <p className="text-sm text-foreground-500">
                株式会社ヴェリテ（以下「当社」）は、お客様の個人情報の保護に努めます。
              </p>
            </div>

            <div className="bg-background-50 rounded-2xl border border-background-200 p-6 md:p-10 space-y-8">
              {sections.map((section, idx) => (
                <div key={idx}>
                  <h3 className="font-heading font-bold text-lg text-foreground-950 mb-3">
                    {section.title}
                  </h3>
                  {section.title === '6. お問い合わせ窓口' ? (
                    <div className="bg-background-100 rounded-lg p-4 space-y-2 text-sm text-foreground-700">
                      <p>株式会社ヴェリテ</p>
                      <p>メール：verite@frise.support</p>
                      <p>TEL：022-211-5488（平日 9:00〜18:00）</p>
                      <p>住所：〒980-0802 宮城県仙台市青葉区二日町14-14 二日町ゲートビル2階</p>
                    </div>
                  ) : (
                    <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                      {section.content}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}